import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router";
import {useAuth} from "../context/authContext.tsx";
import {Employee, loginService} from "../services/employee.ts";
import {AxiosError} from "axios";
import { getAuthenticatedHomeRoute } from "../utils/auth.ts";
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

const Login = () => {
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);


    const {setEmp, employeeI, authReady} = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        if (!authReady || !employeeI) {
            return;
        }
        navigate(getAuthenticatedHomeRoute(employeeI), { replace: true });
    }, [authReady, employeeI, navigate]);

    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await loginService({
                email: email,
                password: password,
            })
            // console.log(result.headers)
            const data: Employee = result.data;
            setEmp(data);
            // console.log(data)
            navigate(getAuthenticatedHomeRoute(data), { replace: true });

            // console.log(result.data)
        } catch (error) {
            // if (error) {
            //     // @ts-ignore
            //     setError(error.response.data.error);
            //     return;
            // }
            if (error instanceof AxiosError) {
                if (error.response) {
                    if (error.response.status === 500) {
                        setError("Something on our end went wrong");
                        setLoading(false);
                        return;
                    }
                    if (error.response.data) {
                        setError(error.response.data.error);
                        setLoading(false);
                        return;
                    }
                    setError("Something went wrong!");
                    setLoading(false);
                    return;
                }
                setError("Something went wrong!");
                setLoading(false);
                return;
            }
            setError("Something went wrong!");

        }

        setLoading(false);

    }

    // setEmp({
    //     fname: res.fname,
    //     lname: res.lname,
    //     mname: res.mname,
    //     email: res.email,
    //     position: res.position,
    //     department: res.department,
    //     division: res.division,
    // });


    return (
        <div className={`w-full h-full`}>
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-20">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img
                        alt="Your Company"
                        src={digitalOceanImageUrl("new%20logos/Asset%205.webp")}
                        className="mx-auto h-10 w-auto"
                    />
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Sign in to your account
                    </h2>
                    {
                        loading && (
                            <p>Loading...</p>
                        )
                    }
                    {
                        error.length > 0 && (
                            <div className={`w-full h-fit mt-4 bg-red-500/20 rounded-sm`}>
                                <p className={`w-full text-center px-2 py-1.5  ring-1 ring-red-500 text-sm text-red-500 font-semibold rounded-sm`}>{error}</p>
                            </div>
                        )
                    }

                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                    <form onSubmit={submitHandler} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                Email address
                            </label>
                            <div className="mt-2">
                                <input
                                    onChange={(e) => setEmail(e.target.value)}
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={email}
                                    required
                                    autoComplete="email"
                                    className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 outline-0 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-between">
                                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                    Password
                                </label>
                                <div className="text-sm">

                                    <Link to={"/forgot_password"} >
                                        <p className="font-semibold text-orange-600 hover:text-red-500 cursor-pointer">
                                            Forgot password?
                                        </p>

                                    </Link>
                                </div>
                            </div>
                            <div className="mt-2">
                                <input
                                    onChange={(e) => setPassword(e.target.value)}
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={password}
                                    required
                                    autoComplete="current-password"
                                    className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  outline-0 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                disabled={loading}
                                type="submit"
                                className="flex w-full justify-center rounded-md bg-orange-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                            >
                                Sign in
                            </button>
                        </div>
                    </form>


                        {/*<Link to="/signup">*/}
                        {/*    <p className="mt-10 text-center text-sm text-gray-500"> Not registered </p>*/}
                        {/*</Link>*/}

                </div>
            </div>
        </div>
    );
};

export default Login;
